import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import {
  ScreenerPresetDisplayType,
  ScreenerPresetId,
  ScreenerPresetName,
  ScreenerPresetState,
} from './presetsTypes';

const savedPreset: ScreenerPresetState = {
  name: '',
  id: '',
  display_type: null,
};

const initialState: ScreenerPresetState = savedPreset;

export const screenerPresetSlice = createSlice({
  name: 'screenerPreset',
  initialState,
  reducers: {
    updateScreenerPresetId: (state, action: PayloadAction<ScreenerPresetId>) => {
      state.id = action.payload.id;
    },
    updateScreenerPresetName: (state, action: PayloadAction<ScreenerPresetName>) => {
      state.name = action.payload.name;
    },
    updateScreenerPresetDisplayType: (state, action: PayloadAction<ScreenerPresetDisplayType>) => {
      state.display_type = action.payload.display_type;
    },
    hardResetScreenerPreset: (state) => {
      state.name = '';
      state.id = '';
      state.display_type = null;
    },
  },
});

export const currentScreenerPreset = (state: RootState) => state.screenerPreset;

export const {
  updateScreenerPresetId,
  updateScreenerPresetName,
  updateScreenerPresetDisplayType,
  hardResetScreenerPreset,
} = screenerPresetSlice.actions;

export const screenerPresetReducer = screenerPresetSlice.reducer;
